
// Applies both tab-filter and size-filter to side-modal mattress labels.
  // Called on popup open, size change, and tab click.
  function applyMattressFilters() {
    // Read selected bed size
    var $sizeRadio = $('input[name="option-1"]:checked');
    var selectedSize = $sizeRadio.length
      ? String($sizeRadio.data('option-value') || $sizeRadio.val())
      : null;
    if (!selectedSize) {
      var $altRadio = $('#size_options input[type="radio"]:checked');
      if ($altRadio.length) selectedSize = $altRadio.val();
    }

    // Read active collection tab ('' = All)
    var activeHandle = $('.mattresses-filter-tab li.active').data('handle') || '';

    $('.mattress-list-ss label').each(function () {
      var $label = $(this);
      var collectionHandle = $label.data('collection-handle') || '';
      var $input = $label.find('input[type="radio"]');
      var variants = $input.data('mattress-variants') || [];

      // Tab filter: show all when "All" active, otherwise match collection
      var tabMatch = !activeHandle || collectionHandle === activeHandle;

      // Size filter: find variant whose title contains the selected size
      var sizeMatch = true;
      var matchedVariant = null;

      if (selectedSize && variants.length) {
        for (var i = 0; i < variants.length; i++) {
          var vTitle = String(variants[i].title || '');
          if (vTitle.toLowerCase().indexOf(selectedSize.toLowerCase()) !== -1) {
            matchedVariant = variants[i];
            break;
          }
        }
        sizeMatch = !!matchedVariant;
      }

      if (tabMatch && sizeMatch) {
        $label.show();
        // Update radio value and displayed price to the size-matched variant
        if (matchedVariant) {
          $input.val(matchedVariant.id);
          var price = matchedVariant.price;
          var formatted = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
            ? Shopify.formatMoney(price)
            : '\u00a3' + (price / 100).toFixed(2);
          $label.find('.mattress-price').text(formatted).attr('data-base-price', price);
        }
      } else {
        $label.hide();
        if ($input.prop('checked')) $input.prop('checked', false);
      }
    });
  }

  // Called when the mattress popup opens.
  function updateMattressPricesForSize() {
    applyMattressFilters();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.close-side-model')) {
      const popup = e.target.closest('.side-model-mattress');

      if (popup) {
        popup.classList.remove('open');
        document.body.classList.remove('mattress-overlay-open');
      }
    }
  });
  const openButtons = document.querySelectorAll('[data-dilog]');

  openButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const popupId = this.getAttribute('data-dilog');
      const popup = document.getElementById(popupId);

      if (popup) {
        popup.classList.add('open');
        document.body.classList.add('mattress-overlay-open');

        // If this is the mattress popup, update prices based on selected size
        if (popupId === 'mattress-pop') {
          updateMattressPricesForSize();
        }
      }
    });
  });
$(document).ready(function () {
  'use strict';

  $('.btn-mattress-cart').on('click', function () {
    const selectedInput = $('.mattress-list-ss input[type="radio"]:checked');
    if (selectedInput.length === 0) {
      alert('Please select a mattress');
      return;
    }

    // Each radio is already the exact variant the user chose — copy its label HTML
    // into the selected state panel and close the popup.
    const InfoHtml = selectedInput.parent().html();
    $('.mattress-add-on.selected').html(InfoHtml).show();
    $('.mattress-add-on.selection').hide();
    $('.side-model-mattress').removeClass('open');
    document.body.classList.remove('mattress-overlay-open');
  });

  $(document).on('click', '.mattress-add-on.selected a.remove-selection', function () {
    $('.mattress-add-on.selected').hide().html('');
    $('.mattress-add-on.selection').show();
  });

  // Mattress type filter tabs — click to filter by collection + re-apply size filter
  $(document).on('click', '.mattresses-filter-tab li', function () {
    $('.mattresses-filter-tab li').removeClass('active');
    $(this).addClass('active');
    applyMattressFilters();
  });


  // =====================================================
  // SECTION 1: UTILITY FUNCTIONS
  // =====================================================


  // on click .product-option-values.option-mattress-values .option-value .mattress-add, .product-option-values.option-assembly-values .option-value .assembly-add nearest input[type="radio"] → check the radio and trigger change (to allow clicking the "+£XX.XX" span)

  $(document).on('click', '.product-option-values.option-mattress-values .option-value .mattress-add, .product-option-values.option-assembly-values .option-value .assembly-add', function (e) {
    e.preventDefault();
    var $optionValue = $(this).closest('.option-value');
    var $radio = $optionValue.find('input[type="radio"]');
    if ($radio.length) {
      $radio.prop('checked', true).trigger('change');
    }
  });

  function formatPrice(priceInCents) {
    return '\u00A3' + (priceInCents / 100).toFixed(2);
  }

  function formatPriceDifference(difference) {
    if (difference === 0) return formatPrice(0);
    var prefix = difference > 0 ? '+' : '-';
    var absoluteValue = Math.abs(difference);
    return prefix + '\u00A3' + (absoluteValue / 100).toFixed(2);
  }

  function getProductVariantsData() {
    var dataScript = document.getElementById('product-variants-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Failed to parse product variants data:', e);
      }
    }
    return { variants: [] };
  }

  function normalizeOptionValue(value) {
    if (!value) return value;
    return value.replace(/["']+$/g, '').trim();
  }

  // =====================================================
  // SECTION 2: VARIANT MATCHING
  // =====================================================

  function findMatchingVariant(selectedOptions) {
    var variantsData = getProductVariantsData();
    var searchOptionCount = 0;
    for (var key in selectedOptions) {
      if (key.indexOf('option') === 0) searchOptionCount++;
    }

    for (var i = 0; i < variantsData.variants.length; i++) {
      var variant = variantsData.variants[i];
      var matchCount = 0;
      var failed = false;

      for (var j = 1; j <= 3; j++) {
        var optionKey = 'option' + j;
        if (selectedOptions[optionKey]) {
          var normalizedSelected = normalizeOptionValue(selectedOptions[optionKey]);
          var normalizedVariant = normalizeOptionValue(variant[optionKey]);
          if (normalizedVariant === normalizedSelected) {
            matchCount++;
          } else {
            failed = true;
            break;
          }
        }
      }

      if (!failed && matchCount === searchOptionCount && matchCount > 0) {
        return variant;
      }
    }
    return null;
  }

  function getSelectedProductOptions() {
    var selectedOptions = {};
    $('.product-option input[type="radio"][data-option-position]:checked').each(function () {
      var optionPosition = parseInt($(this).data('option-position'));
      var optionValue = $(this).data('option-value') || $(this).val();
      if (optionPosition && optionValue) {
        selectedOptions['option' + optionPosition] = String(optionValue);
      }
    });
    return selectedOptions;
  }

  // =====================================================
  // SECTION 3: PRICE CALCULATION ENGINE
  // =====================================================

  function updateVariantPrices() {
    var totalPrice = 0;
    var totalCompareAtPrice = 0;
    var hasCompareAt = false;

    // 1. Get base variant price
    var selectedOptions = getSelectedProductOptions();
    var matchingVariant = findMatchingVariant(selectedOptions);

    if (matchingVariant) {
      totalPrice = matchingVariant.price;
      if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > 0) {
        totalCompareAtPrice = matchingVariant.compare_at_price;
        hasCompareAt = true;
      }
    } else {
      // Fallback for single-variant products
      var variantsData = getProductVariantsData();
      if (variantsData.variants.length === 1) {
        totalPrice = variantsData.variants[0].price;
        if (variantsData.variants[0].compare_at_price && variantsData.variants[0].compare_at_price > 0) {
          totalCompareAtPrice = variantsData.variants[0].compare_at_price;
          hasCompareAt = true;
        }
      }
    }

    // 2. Add metafield addon prices
    $('.product-option input[type="radio"]:checked[data-price]').each(function () {
      // Skip product variant options (they have data-option-position)
      if ($(this).data('option-position')) return;
      // Skip mattress and assembly
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      var price = parseInt($(this).data('price')) || 0;
      totalPrice += price;
      if (hasCompareAt) {
        totalCompareAtPrice += price;
      }
    });

    // 3. Add mattress price
    var $selectedMattress = $('input[name="option-mattress"]:checked');
    if ($selectedMattress.length && $selectedMattress.val()) {
      var mattressPrice = parseInt($selectedMattress.data('price')) || 0;
      totalPrice += mattressPrice;
      if (hasCompareAt) {
        totalCompareAtPrice += mattressPrice;
      }
    }

    // 4. Add assembly price
    var $selectedAssembly = $('input[name="option-assembly"]:checked');
    if ($selectedAssembly.length && $selectedAssembly.val()) {
      var assemblyPrice = parseInt($selectedAssembly.data('price')) || 0;
      totalPrice += assemblyPrice;
      if (hasCompareAt) {
        totalCompareAtPrice += assemblyPrice;
      }
    }

    // 5. Update price display
    var $priceContainer = $('h3.product-price');
    var $priceBox = $('.product-option-main .product-price-box');
    var formattedCurrent = '£' + Math.round(totalPrice / 100);
    $priceContainer.find('.product-price--current').text(formattedCurrent);

    // 5b. Mirror the live total inside the sticky add-to-basket button
    $('.lmb-sticky-atc__button-price').text(formattedCurrent);

    // 6. Update compare-at price and savings
    if (hasCompareAt && totalCompareAtPrice > totalPrice) {
      $priceContainer.find('.product-price--compare').text('£' + Math.round(totalCompareAtPrice / 100)).show();

      var savings = totalCompareAtPrice - totalPrice;
      $priceContainer.find('.product-price--discount').text('You Save £' + Math.round(savings / 100)).show();
    } else {
      $priceContainer.find('.product-price--compare').hide();
      $priceContainer.find('.product-price--discount').hide();
    }

    // 6b. Update finance monthly amount (8-month split)
    var $financeAmount = $priceBox.find('.product-price--finance-amount');
    if ($financeAmount.length) {
      $financeAmount.text(formatPrice(Math.round(totalPrice / 12)));
    }

    // 7. Update per-option price differences
    updatePriceDifferences(selectedOptions, matchingVariant);

    // 8. Update accordion header labels
    updateAccordionLabels();
  }

  // =====================================================
  // SECTION 4: PRICE DIFFERENCES
  // =====================================================

  function updatePriceDifferences(selectedOptions, currentVariant) {
    var currentPrice = currentVariant ? currentVariant.price : 0;

    // Product option radios (have data-option-position) — show +/- difference
    $('.product-option').each(function () {
      var $section = $(this);
      var $radios = $section.find('input[type="radio"][data-option-position]');
      if ($radios.length === 0) return;

      $radios.each(function () {
        var $radio = $(this);
        var optionValue = String($radio.data('option-value') || $radio.val());
        var optionPosition = parseInt($radio.data('option-position'));
        var $label = $radio.closest('.option-value');
        var $priceSpan = $label.find('.variant-price');

        // Build hypothetical options with this value swapped in
        var hypothetical = $.extend({}, selectedOptions);
        if (optionValue && optionPosition) {
          hypothetical['option' + optionPosition] = optionValue;
        }

        var hypotheticalVariant = findMatchingVariant(hypothetical);
        var hypotheticalPrice = hypotheticalVariant ? hypotheticalVariant.price : 0;

        if (!hypotheticalVariant) {
          $radio.prop('disabled', true);
          $label.addClass('unavailable');
          $priceSpan.text('');
        } else {
          $radio.prop('disabled', false);
          $label.removeClass('unavailable');
          var priceDifference = hypotheticalPrice - currentPrice;
          $priceSpan.text(formatPriceDifference(priceDifference));
        }
      });
    });

    // Metafield option radios (have data-price, no data-option-position) — show as +£XX.XX
    $('.product-option input[type="radio"][data-price]').each(function () {
      if ($(this).data('option-position')) return;
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      var variantPrice = parseInt($(this).data('price')) || 0;
      var $label = $(this).closest('.option-value');
      var $priceSpan = $label.find('.variant-price');

      if ($priceSpan.length) {
        if (variantPrice > 0) {
          $priceSpan.text('+' + formatPrice(variantPrice));
        } else {
          $priceSpan.text(formatPrice(variantPrice));
        }
      }
    });
  }

  // =====================================================
  // SECTION 5: ACCORDION LABELS
  // =====================================================

  function updateAccordionLabels() {
    $('.product-option').each(function () {
      var $section = $(this);
      var $selected = $section.find('.option-value input[type="radio"]:checked');
      if ($selected.length) {
        var selectedName = $selected.data('name') || $selected.val();
        $section.find('h3 span b').text(selectedName);
      }
    });
  }

  // =====================================================
  // SECTION 6: SIZE-BASED FILTERING
  // =====================================================

  function getSelectedSize() {
    var $sizeRadio = $('input[name="option-1"]:checked');
    if ($sizeRadio.length) {
      return String($sizeRadio.data('option-value') || $sizeRadio.val());
    }
    var $altRadio = $('#size_options input[type="radio"]:checked');
    if ($altRadio.length) {
      return $altRadio.val();
    }
    return null;
  }

  function filterMattressBySize() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) return;

    const countselectedSize = document.querySelectorAll(
      `.product-option-values .option-value[data-mattress-size="${selectedSize}"]`
    ).length;

    if(countselectedSize == 0){
      $('p.no-mattress-message').show();
    }else{
      $('p.no-mattress-message').hide();
    }

    $('.option-mattress-values .option-value').each(function () {
      var mattressSize = $(this).data('mattress-size');
      // Always show "No Mattress" or items without a size
      if (!mattressSize || mattressSize === 'No Mattress' || mattressSize === selectedSize) {

        $(this).show();
      } else {
        $(this).hide();
        var $radio = $(this).find('input[type="radio"]');
        if ($radio.prop('checked')) {
          $radio.prop('checked', false);
        }
      }
    });

    // Also filter side-modal labels by size + active tab
    applyMattressFilters();
  }

  function filterStorageOptions() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) return;

    var smallSizes = ['Small Single (2FT6)', 'Single (3FT)'];
    var isSmallSize = smallSizes.indexOf(selectedSize) !== -1;
    var restrictedOptions = ['Footend 2 Drawers', '4 Drawers'];

    $('.product-option').each(function () {
      var $section = $(this);
      var sectionTitle = $section.find('h3 span').first().text().toLowerCase();

      if (sectionTitle.indexOf('storage') === -1 && sectionTitle.indexOf('drawer') === -1) return;

      $section.find('.option-value').each(function () {
        var $label = $(this);
        var optionText = $label.find('span').first().text().trim();
        var $radio = $label.find('input[type="radio"]');

        if (isSmallSize && restrictedOptions.indexOf(optionText) !== -1) {
          $label.hide();
          if ($radio.prop('checked')) {
            $radio.prop('checked', false);
            var $firstVisible = $section.find('.option-value:visible input[type="radio"]').first();
            if ($firstVisible.length) {
              $firstVisible.prop('checked', true);
            }
          }
        } else {
          $label.show();
        }
      });
    });
  }

  // =====================================================
  // SECTION 7: VALIDATION
  // =====================================================

  // Resolve a clean section title for a .product-option.
  // Prefer the data-section-title emitted in Liquid; fall back to the heading
  // text with the injected selected-value <b> and the sub-heading <p> removed
  // (scraping h3 span text directly pulls those in and pollutes the property name).
  function getSectionTitle($section) {
    var attrTitle = $section.attr('data-section-title');
    if (attrTitle) return attrTitle.trim();

    var $heading = $section.find('h3 .title-icon-accordion').first();
    if (!$heading.length) $heading = $section.find('h3 span').first();
    var $clone = $heading.clone();
    $clone.find('b, p, img, br').remove();
    return $clone.text().replace(/Choose\s+/i, '').replace(/\s*-\s*$/, '').trim();
  }

  function validateMetafieldSelections() {
    var errors = [];

    $('.product-option').each(function () {
      var $section = $(this);
      var $radios = $section.find('.option-value input[type="radio"]');
      if ($radios.length === 0) return;

      // Skip product variant options (they always have a default checked)
      if ($radios.first().data('option-position')) return;

      // Skip mattress and assembly (they are optional)
      var radioName = $radios.first().attr('name');
      if (radioName === 'option-mattress' || radioName === 'option-assembly') return;

      var $selected = $section.find('.option-value input[type="radio"]:checked');
      if ($selected.length === 0) {
        var sectionTitle = getSectionTitle($section);
        errors.push({
          sectionTitle: sectionTitle,
          $section: $section
        });
      }
    });

    return errors;
  }

  function showError(message) {
    $('.product-option-error').remove();
    var $error = $('<div class="product-option-error"></div>').text(message);
    $error.insertBefore('.add-to-cart-btn');
  }

  function clearErrors() {
    $('.product-option-error').remove();
    $('.product-option.error').removeClass('error');
  }

  // =====================================================
  // SECTION 8: ADD TO CART
  // =====================================================

  function generateBundleId() {
    return 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  function getMainProductTitle() {
    var $title = $('.product__title h1');
    if (!$title.length) $title = $('h1.product__title');
    if (!$title.length) $title = $('[data-product-title]');
    return $title.length ? $title.text().trim() : 'Main Product';
  }

  function handleAddToCart(e) {
    e.preventDefault();
    clearErrors();

    var $btn = $(e.target);

    // Validate metafield selections
    var validationErrors = validateMetafieldSelections();
    if (validationErrors.length > 0) {
      validationErrors.forEach(function (error) {
        error.$section.addClass('error');
      });
      var missingOptions = validationErrors.map(function (e) { return e.sectionTitle; }).join(', ');
      showError('Please select an option for: ' + missingOptions);

      // Open first erroring accordion and scroll to it
      var $firstError = validationErrors[0].$section;
      $firstError.find('.product-option-values').addClass('active');
      $('html, body').animate({
        scrollTop: $firstError.offset().top - 100
      }, 400);
      return;
    }

    // Get main variant
    var selectedOptions = getSelectedProductOptions();
    var mainVariant = findMatchingVariant(selectedOptions);

    if (!mainVariant) {
      var variantsData = getProductVariantsData();
      mainVariant = variantsData.variants[0] || null;
    }

    if (!mainVariant) {
      showError('Please select a valid product variant.');
      return;
    }

    // Collect metafield variant selections
    var metafieldVariants = [];
    var bundleId = generateBundleId();
    var mainProductTitle = getMainProductTitle();
    var mainProductProperties = { '_bundle_id': bundleId };

    $('.product-option input[type="radio"]:checked[data-variant-id]').each(function () {
      if ($(this).data('option-position')) return;
      var name = $(this).attr('name');
      if (name === 'option-mattress' || name === 'option-assembly') return;

      var variantId = parseInt($(this).data('variant-id'));
      var variantTitle = $(this).data('name') || '';
      var sectionTitle = getSectionTitle($(this).closest('.product-option'));

      metafieldVariants.push({
        id: variantId,
        title: variantTitle,
        sectionTitle: sectionTitle
      });

      mainProductProperties[sectionTitle] = variantTitle;
    });

    // Get selected quantity
    var qty = parseInt($('#quantity').val()) || 1;

    // Build cart items
    var cartItems = [];

    // Main product
    cartItems.push({
      id: mainVariant.id,
      quantity: qty,
      properties: mainProductProperties
    });

    // Metafield child products
    metafieldVariants.forEach(function (variant) {
      cartItems.push({
        id: variant.id,
        quantity: qty,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    });

    // Mattress — side modal first (when confirmed), fall back to accordion
    var mattressId = 0;
    if ($('.mattress-add-on.selected').is(':visible')) {
      var $sideModalMattress = $('.mattress-list-ss input[name="mattress_option"]:checked');
      if ($sideModalMattress.length && $sideModalMattress.val()) {
        mattressId = parseInt($sideModalMattress.val());
      }
    }
    if (!mattressId) {
      var $accordionMattress = $('input[name="option-mattress"]:checked');
      if ($accordionMattress.length && $accordionMattress.val()) {
        mattressId = parseInt($accordionMattress.val());
      }
    }
    if (!isNaN(mattressId) && mattressId > 0) {
      cartItems.push({
        id: mattressId,
        quantity: qty,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    }

        // Assembly — dropdown first, fall back to accordion.
    // There can be more than one select[name="assembly_options"] on the page
    // (e.g. the .info-desktop block and the buy-box block), so check them all
    // and take the one that has a value selected — .val() alone only reads the first.
    var assemblyId = 0;
    $('select[name="assembly_options"]').each(function () {
      var v = parseInt($(this).val());
      if (!isNaN(v) && v > 0) assemblyId = v;
    });
    if (!assemblyId) {
      var $accordionAssembly = $('input[name="option-assembly"]:checked');
      if ($accordionAssembly.length && $accordionAssembly.val()) {
        assemblyId = parseInt($accordionAssembly.val());
      }
    }
    if (!isNaN(assemblyId) && assemblyId > 0) {
      cartItems.push({
        id: assemblyId,
        quantity: qty,
        properties: {
          '_bundle_id': bundleId,
          '_parent_product': mainProductTitle
        }
      });
    }

    // Disable button and show loading
    $btn.addClass('loading').text('Adding...').css('pointer-events', 'none');

    // Submit to Shopify AJAX API
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ items: cartItems }),
      dataType: 'json',
      success: function () {
        window.location.href = '/cart';
      },
      error: function (xhr) {
        var errorMsg = 'Failed to add to cart. Please try again.';
        try {
          var data = JSON.parse(xhr.responseText);
          if (data.description) errorMsg = data.description;
        } catch (err) {}
        showError(errorMsg);
        $btn.removeClass('loading').text('Add to Cart').css('pointer-events', 'auto');
      }
    });
  }

  // =====================================================
  // SECTION 9: FABRIC TYPE FILTERING
  // =====================================================

  function handleFabricTypeChange() {
    var selectedFabric = $(this).val();
    var $section = $(this).closest('.product-option');
    var $fabricOptions = $section.find('.option-value[data-combo]');

    if (!selectedFabric || !$fabricOptions.length) return;

    var $matchingOptions = $fabricOptions.filter(function () {
      return String($(this).data('combo')) === String(selectedFabric);
    });

    $fabricOptions.each(function () {
      var $option = $(this);
      var isMatch = String($option.data('combo')) === String(selectedFabric);
      $option.toggle(isMatch);
    });

    var $selected = $fabricOptions.find('input[type="radio"]:checked').closest('.option-value');
    if (!$selected.length || String($selected.data('combo')) !== String(selectedFabric)) {
      var $firstMatching = $matchingOptions.first().find('input[type="radio"]');
      if ($firstMatching.length) {
        $firstMatching.prop('checked', true).trigger('change');
        updateVariantPrices();
        return;
      }
    }

    updateVariantPrices();
  }

  // =====================================================
  // SECTION 10: EVENT BINDING & INITIALIZATION
  // =====================================================

  // Accordion toggle
  $('.product-option h3').click(function (e) {
    e.preventDefault();
    $(this).closest('.product-option').find('.product-option-values').toggleClass('active');
    $(this).find('.icon-accordion').toggleClass('rotated');
  });

  // Fabric type filtering
  $('.fabric-type-input').on('change', handleFabricTypeChange);
  $('.fabric-type-input:checked').each(function () {
    handleFabricTypeChange.call(this);
  });

  // All radio changes → recalculate prices
  $('.product-option-main').on('change', 'input[type="radio"]', function () {
    updateVariantPrices();
    clearErrors();

    // If size changed, re-filter mattress and storage
    var optionPos = $(this).data('option-position');
    if (optionPos == 1 || $(this).attr('name') === 'option-1') {
      filterMattressBySize();
      filterStorageOptions();
      // Recalculate after filtering (options may have been deselected)
      updateVariantPrices();
    }
  });

  // Add-to-cart button
  $(document).on('click', '.add-to-cart-btn', handleAddToCart);

  // Initial mattress size filtering
  filterMattressBySize();

  // Initial calculations
  setTimeout(function () {
    updateVariantPrices();
    filterStorageOptions();
  }, 100);

  // Open first accordion by default
  $('.product-option:first-child .product-option-values').addClass('active');
});
